 <div class="grid">
  <div>
      <ngx-codemirror #codeeditor
      [(ngModel)]="textAreaValue" [options]="{
        lineNumbers: true,
        theme: 'default',
        mode: 'htmlembedded',
        lineWrapping: 'true', 
        styleActiveLine: {nonEmpty: true}, 
        matchTags: {bothTags: true},
        extraKeys: {'Ctrl-J': 'toMatchingTag'}
      }"
      (cursorActivity)="cursorChange($event)">
      </ngx-codemirror> 
    </div> 
 
    <div>
      <iframe id='iframePreview'>  
      </iframe>  
    </div> 
       

</div>


 
<div class="keyNotes">

    <div>
      Ctrl-F / Cmd-F
      <div class="keyDescription">Start searching</div>
    </div>
    <div>
        Shift-Ctrl-F / Cmd-Option-F
      <div class="keyDescription">Replace</div>
    </div>
    <div>
        Shift-Ctrl-R / Shift-Cmd-Option-F
      <div class="keyDescription">Replace all</div>
    </div>  

  </div>
  

 
 
 
 